import { initializeApp } from "firebase/app";
import { getAuth, EmailAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDvQkA0GtEjtpP6Wigf9sU1n610S8Q8Mas",
  authDomain: "itsm-solution.firebaseapp.com",
  projectId: "itsm-solution",
  storageBucket: "itsm-solution.firebasestorage.app",
  messagingSenderId: "979790204250",
  appId: "1:979790204250:web:4080d03e1075f029f67763",
  measurementId: "G-D263R60M0S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Authentication
const auth = getAuth(app);

// Initialize Firestore and Analytics
const db = getFirestore(app);
const analytics = getAnalytics(app); // Optional: Only if you use Analytics

// FirebaseUI config
const uiConfig = {
  //signInFlow: "popup", // Or 'redirect', depending on your preference
  signInOptions: [
    GoogleAuthProvider.PROVIDER_ID,
    EmailAuthProvider.PROVIDER_ID, // Ensure Email provider is included
  ],
  signInSuccessUrl: "/", // URL to redirect to after successful login/signup
};

export { db, analytics, auth, uiConfig };